module.exports = __webpack_public_path__ + "static/img/1.cd04b795.jpg";